import { Injectable } from '@angular/core'
import { PowerBIServiceApi } from '../../../core/services/PowerBIService'

@Injectable()

export class PowerbiReportViewerService {
  constructor(private _powerBIServiceApi: PowerBIServiceApi) { }

  
  getEmbedInfo(workspaceId, reportId) : any {
      const params: PowerBIServiceApi.PowerBI_GetEmbedInfoParams = {
          workspaceId: workspaceId,
          reportId: reportId,
      };

      return this._powerBIServiceApi.PowerBI_GetEmbedInfo(params);
  }

  getEmbedInfoByPathName(workspaceId, pathName): any {
    const params: PowerBIServiceApi.PowerBI_GetEmbedInfoByPathNameParams = {
      workspaceKey: workspaceId,
      pathName: pathName,
    };

    return this._powerBIServiceApi.PowerBI_GetEmbedInfoByPathName(params);
  }

  getEmbedInfoForCreate(workspaceId, datasetId): any {
    const params: PowerBIServiceApi.PowerBI_GetEmbedInfoForCreateParams = {
      workspaceId: workspaceId,
      datasetId: datasetId,
    };

    return this._powerBIServiceApi.PowerBI_GetEmbedInfoForCreate(params);
  }

}



// WEBPACK FOOTER //
// ./src/app/submission/components/powerbi-report-viewer/powerbi-report-viewer.service.ts